export default "__VITE_ASSET__f802c052__"